<template>
  <div class="os-host-insight">
    <el-row :type="'flex'" class="basic-insights" :gutter="20" style="width:100%">
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <insight-card 
          ref="ips"
          type="external-ips"
          name="ext-ip-insights"
          :title="'External Connections'"
          :selDate="hostInsightsDateRangeUserSetting"
          :agentId="agentId"
          :os-type="osType"
          @updated="insightsUpdated"
          @row-click="gotoThreatHunting"
        ></insight-card>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <insight-card 
          ref="logins"
          type="login-failures"
          name="system-logins-insights"
          :title="'Login Failures'"
          :selDate="hostInsightsDateRangeUserSetting"
          :agentId="agentId"
          :os-type="osType"
          @updated="insightsUpdated"
          @row-click="gotoThreatHunting"
        ></insight-card>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <insight-card 
          ref="privileged"
          type="privileged-execs"
          name="privileged-execs-insights"
          :title="'Privilege Executions'"
          :selDate="hostInsightsDateRangeUserSetting"
          :agentId="agentId"
          :os-type="osType"
          @updated="insightsUpdated"
          @row-click="gotoThreatHunting"
        ></insight-card>
      </el-col>
    </el-row>
    <el-row :type="'flex'" class="basic-insights" :gutter="20">
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <insight-card
          ref="shells"
          type="process-launching-shells"
          name="process-launching-shells"
          :title="'Process Launching Shells'"
          :selDate="hostInsightsDateRangeUserSetting"
          :agentId="agentId"
          :os-type="osType"
          @updated="insightsUpdated"
          @row-click="gotoThreatHunting"
        ></insight-card>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
        <insight-card
          ref="fileaccess"
          type="sensitive-file-access"
          name="sensitive-file-access"
          :title="'Sensitive File Access'"
          :selDate="hostInsightsDateRangeUserSetting"
          :agentId="agentId"
          :os-type="osType"
          @updated="insightsUpdated"
          @row-click="gotoThreatHunting"
        ></insight-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InsightCard from '@/views/hosts/InsightCard.vue'
import { HOST_INSIGHTS_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'

export default {
  name: 'LinuxHostInsights',
  props: {
    agentId: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  data () {
    return {
      daterangeUserPrefConstant: HOST_INSIGHTS_DATE_RANGE_PREFERENCE,
      osType: 'linux',
      activeInsightsCollapse: []
    }
  },
  created () {},
  methods: {
    loadTabInsights () {
      this.$refs.ips.fetchHostInsights()
      this.$refs.logins.fetchHostInsights()
      this.$refs.privileged.fetchHostInsights()
      this.$refs.shells.fetchHostInsights()
      this.$refs.fileaccess.fetchHostInsights()
    },
    insightsUpdated (update) {
      let name = update.name
      let actives = this.activeInsightsCollapse
      if (update.hasChartData) {
        actives.push(name)
      }
    },
    gotoThreatHunting (type) {
      if (!this.insightsEnabled) {
        return false
      }
      let threatHuntParam = `date_range:${this.hostInsightsDateRangeUserSetting}`
      switch (type.name) {
        case 'dns-requests':
          threatHuntParam = `${threatHuntParam}+edgeName:in:network:exec+topLevelDomain:eq:${type.row['topLevelDomain']}+agentId:eq:${this.agentId}`
          break
        case 'external-ips':
          threatHuntParam = `${threatHuntParam}+edgeName:in:network+destAddr:not_equal:null+sourceComm:eq:${type.row['sourceComm']}+agentId:eq:${this.agentId}`
          break
        case 'login-failures':
          threatHuntParam = `${threatHuntParam}+edgeName:in:1109:1100+externalDestAddr:eq:true+destAddr:eq:${type.row['argsAddr']}+agentId:eq:${this.agentId}`
          break
        case 'privileged-execs':
          // edgeName:in:execve+sourceBinaryName:eq:/usr/bin/vmtoolsd+os:eq:Linux+parentComm:in:bash:sh:dash+sourceEuid:eq:0+sourceBinaryName:not_equal:
          threatHuntParam = `${threatHuntParam}+edgeName:in:execve+parentComm:in:bash:sh:dash+sourceBinaryName:eq:${type.row['sourceBinaryName']}+agentId:eq:${this.agentId}+sourceEuid:eq:0`
          break
        case 'process-launching-shells':
          // edgeName:in:execve+os:eq:Linux+sourceComm:in:bash:sh:dash+parentComm:eq:runc:[0:PARENT]
          threatHuntParam = `${threatHuntParam}+edgeName:in:execve+sourceComm:in:bash:sh:dash+parentComm:eq:${type.row['parentComm']}+agentId:eq:${this.agentId}`
          break
        case 'sensitive-file-access':
          // edgeName:in:file+sourceBinaryName:eq:/usr/sbin/sshd+os:eq:Linux+targetPathName:matches:/etc/.*
          threatHuntParam = `${threatHuntParam}+edgeName:in:file+targetPathName:matches:/etc/.*+sourceBinaryName:eq:${type.row['sourceBinaryName']}+agentId:eq:${this.agentId}`
          break
        default:
          threatHuntParam = `${threatHuntParam}+edgeName:in:clone:ProcessStart+sourceComm:eq:${type.row['sourceComm']}+agentId:eq:${this.agentId}`
          break
      }
      this.$router.push({
        name: 'threat-hunting',
        query: { search: threatHuntParam }
      })
    }
  },
  computed: {
    ...mapGetters([
      'insightsEnabled',
      'agentDetailsReqStatus',
      'hostInsightsDateRangeUserSetting',
      'hrlyDnsRequestStatisticsReqStatus',
      'hrlyExternalIpStatisticsReqStatus',
      'hrlyLoginFailuresStatisticsReqStatus',
      'hrlyPrivilegedExecStatisticsReqStatus',
      'hostEventCompositionReqStatus'
    ])
  },
  components: {
    InsightCard
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.hosts-dashboard-content {
  overflow: scroll;
  height: calc(100% - 145px);
}

.insight-graphs {
  height: 350px;
  margin: 0px 0px 15px 0px;
}

.workload-profiler_header {
  height: 36px;
  padding-left: 15px;
  margin-bottom: 20px;
  font-weight: 700;
  background: var(--gray-100);
}

.scroll-menu {
  position: fixed;
}
.scroll-menu h5 {
  margin-top: 0.5em;
  margin-bottom: 1.5em;
}
.scroll-menu a {
  display: block;
  margin: 0.5em 0;
}

.most-active-insights,
.basic-insights {
  min-height: 350px;
  padding-bottom: 20px;
}

.top-ten_list {
  min-height: 255px;
}

.empty_text {
  min-height: 280px;
}

.topten-entities {
  height: 100% !important;
}

>>> .el-collapse-item__header {
  height: 36px;
  padding-left: 15px;
  font-weight: 700;
  background: #f4f4f4;
}

>>> .el-collapse-item__content {
  padding: 15px;

  .name {
    color: #999999;
    font-size: 12px;
    font-weight: bold;
  }

  .el-row {
    margin-bottom: 5px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/hosts/LinuxHostInsights.vue